import {otherMenu} from '@/config/menu'

function search (menus, key) {
  for (let i = 0; i < menus.length; i++) {
    if (menus[i].subMenu) {
      const result = search(menus[i].subMenu, key)
      if (result) {
        return result
      }
    } else {
      if (menus[i].key === key) {
        return menus[i]
      }
    }
  }
}

export default {
  namespaced: true,
  state: {
    menuList: []
  },
  mutations: {
    update (state, payload) {
      state.menuList = payload.menuList
    }
  },
  getters: {
    getItem (state) {
      return key => {
        // 遍历mainMenu（已做权限过滤）
        const item = search(state.menuList, key)
        if (item) {
          return item
        }
        // 遍历otherMenu
        for (let i = 0; i < otherMenu.length; i++) {
          if (key === otherMenu[i].key) {
            return otherMenu[i]
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/menu/index.js